import { map } from 'lodash';
import { IFilterValue } from '@modules/Dashboard/dashboard.model';

export class ArrayHelper {
    static convertArrayToString(model: null | IFilterValue[], key: string): string {
      return map(model, key).join(',');
    }
  }
